export enum GroupListContent {
	GROUPS = 'groups',
	PATIENTS = 'patients',
	GROUPS_DELETE = 'groupsDelete',
	MESSAGES = 'messages',
}
